var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2783_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66663V4.33329C13.3333 3.39987 13.3333 2.93316 13.1516 2.57664C12.9918 2.26304 12.7369 2.00807 12.4233 1.84828C12.0668 1.66663 11.6 1.66663 10.6666 1.66663H4.33329C3.39987 1.66663 2.93316 1.66663 2.57664 1.84828C2.26304 2.00807 2.00807 2.26304 1.84828 2.57664C1.66663 2.93316 1.66663 3.39987 1.66663 4.33329V10.6666C1.66663 11.6 1.66663 12.0668 1.84828 12.4233C2.00807 12.7369 2.26304 12.9918 2.57664 13.1516C2.93316 13.3333 3.39987 13.3333 4.33329 13.3333H6.66663M9.99996 12.5L11.6666 14.1666L15.4166 10.4166M9.33329 18.3333H15.6666C16.6 18.3333 17.0668 18.3333 17.4233 18.1516C17.7369 17.9918 17.9918 17.7369 18.1516 17.4233C18.3333 17.0668 18.3333 16.6 18.3333 15.6666V9.33329C18.3333 8.39987 18.3333 7.93316 18.1516 7.57664C17.9918 7.26304 17.7369 7.00807 17.4233 6.84828C17.0668 6.66663 16.6 6.66663 15.6666 6.66663H9.33329C8.39987 6.66663 7.93316 6.66663 7.57664 6.84828C7.26304 7.00807 7.00807 7.26304 6.84828 7.57664C6.66663 7.93316 6.66663 8.39987 6.66663 9.33329V15.6666C6.66663 16.6 6.66663 17.0668 6.84828 17.4233C7.00807 17.7369 7.26304 17.9918 7.57664 18.1516C7.93316 18.3333 8.39987 18.3333 9.33329 18.3333Z",
    stroke: "#848F9A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2783_1460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityUnselected);
export default __webpack_public_path__ + "static/media/ActivityUnselected.0527f40bd04989a594cd95cacf145904.svg";
export { ForwardRef as ReactComponent };